import React, { useState } from "react";
import UserAvatar from "./UserAvatar";
import {
  DropdownContainer,
  DropdownSearch,
  DropdownList,
  DropdownItem,
  DropdownItemName,
  DropdownItemMeta,
  DropdownItemEmail,
  DropdownEmpty,
} from "./Avatar.styled";

/**
 * Searchable dropdown overlay showing a list of users with avatars.
 *
 * @param {Array}    users        — [{ id, name, email, meta }]
 * @param {boolean}  open         — visibility toggle
 * @param {function} onClose      — called to dismiss
 * @param {number}   [anchorWidth] — dropdown width in px
 */
const UserDropdown = ({ users = [], open, onClose, anchorWidth = 260 }) => {
  const [query, setQuery] = useState("");
  const filtered = users.filter((u) =>
    u.name?.toLowerCase().includes(query.toLowerCase())
  );

  if (!open) return null;

  return (
    <DropdownContainer $width={anchorWidth} onMouseLeave={onClose}>
      <DropdownSearch
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search user…"
      />
      <DropdownList>
        {filtered.length ? (
          filtered.map((u) => (
            <DropdownItem key={u.id}>
              <UserAvatar user={u} size={26} />
              <div style={{ minWidth: 0 }}>
                <DropdownItemName>{u.name}</DropdownItemName>
                {u.meta && <DropdownItemMeta>{u.meta}</DropdownItemMeta>}
                {u.email && <DropdownItemEmail>{u.email}</DropdownItemEmail>}
              </div>
            </DropdownItem>
          ))
        ) : (
          <DropdownEmpty>No users found</DropdownEmpty>
        )}
      </DropdownList>
    </DropdownContainer>
  );
};

export default UserDropdown;
